import home from './src/home.vue'
import UniformSysConfigView from './src/UniformSysConfigManager/UniformSysConfigView.vue' //统一配置列表
//import POIManagerEdit from './src/UniformSysConfigManager/POIManagerEdit.vue' //地图POI点位管理详情

let views = {
    home,
    UniformSysConfigView,
   // POIManagerEdit
};

export default views;